import LegacyPanel from './LegacyPanel';
import PanelRule from './PanelRule';

export default LegacyPanel;
export { PanelRule };
